/**
 * soubor se seznamem veškerých graphql dotazů pro zákazníka
 */
import gql from 'graphql-tag';

/**
 * vložení a editace zákazníka
 */
export const ADD_EDIT_CUSTOMER = gql`
    mutation AddEditCustomer(
        $customerID:ID,
        $name: String,
        $surname: String,
        $company: String,
        $email: String,
        $tel: String,
        $street: String,
        $city: String,
        $zip: String,
        $countryID:ID,
        $domainID:ID,
        $autoPayments:Int,
        $membershipDuration:ID,
        $description: String
    ){
        addEditCustomer(
            customerID:          $customerID,
            name:                $name,
            surname:             $surname,
            company:             $company,
            email:               $email,
            tel:                 $tel,
            street:              $street,
            city:                $city,
            zip:                 $zip,
            countryID:           $countryID,
            domainID:            $domainID,
            description:         $description,
            autoPayments:        $autoPayments,
            membershipDuration:  $membershipDuration,
        ){
            customerID
            name
            surname
            company
            email
            tel 
            membershipTo
            membershipDuration
            autoPayments
            membership{
                name
            }        
        }
    }
`;

/**
 *  Data pro jednoho zákazníka
 */

export const GET_CUSTOMER_BY_EMAIL = gql`
    query CustomerByEmail($email: String!,$customerID:ID!){
        customerByEmail(email:$email,customerID:$customerID){
            customerID
        }
    }
`;

/**
 *  Data pro jednoho zákazníka
 */

export const GET_CUSTOMER = gql`
    query Customer($customerID: ID!,$lang: String!){
        oneCustomer(customerID:$customerID){
            customerID
            name
            surname
            company
            email
            tel
            street
            city
            zip
            countryID
            domainID
            description
            autoPayments
            membershipDuration
        }
        allCountries{
            countryID
            name
            defaultSelected
        }
        allAdminMembershipDurations(lang:$lang){
            membershipDurationID
            name
            value
        }
        allDomains{
            domainID
            domainName
        }
        
    }
`;

/**
 *  Seznam veškerých zákazníků
 */
export const GET_CUSTOMERS = gql`
    query AllCustomers($offset:Int, $limit: Int,$text:String){
        allCustomers(offset:$offset,limit:$limit,text:$text){
            customerID
            name
            surname
            company
            email
            tel 
            membershipTo
            membershipDuration
            autoPayments
            membership{
                name
            }
        }
        
    }
`;

/**
 * Smazání zákazníka.
 */
export const DELETE_CUSTOMER = gql`
    mutation deleteCustomers($customerID:ID!) {
        deleteCustomers(customerID:$customerID)
    }
`;

/**
 *  seznam veškerých faktur zákazníka
 */

export const GET_CUSTOMERS_INVOICES = gql`
    query CustomerInvoices($offset:Int, $limit: Int,$customerID:ID){
        allCustomerInvoices(offset:$offset,limit:$limit,customerID:$customerID){
            invoiceID
            invoiceNumber
            dateAddStr
            totalPrice
            dueDateStr
            items{
                invoiceItemID
                text
                count
                amount
            }
        } 
    }
`;
